import React from 'react';
import './eventCard.css'
import { useNavigate } from 'react-router';
function C2wEventCard( {onIncubatorsClick,  obj, index, activeIndex } ) {
    const isActive = index === activeIndex;
    const activeGradient = 'linear-gradient(rgba(51, 54, 89, 1), rgba(31, 33, 54, 1))';
    const navigate = useNavigate(null)
    return (
        <div className='C2wEventCard_ctn' style={{borderBottom: index=== 2 ?  'none' : ''}} onClick={index === 0 ? () =>  onIncubatorsClick() : index === 1 ? () => navigate('/superx') : null}>
            <div className='C2wEventCard_ctn_card' style={{background: isActive ? activeGradient : 'transparent', }}>
                <div className='C2wEventCard_ctn_card_logo'>       
                    <img src={obj?.imgSrc} alt='incubators' />
                    <span className='C2wEventCard_ctn_card_logo_heading'>{obj?.tagTitle}</span>
                </div>
                <div className={`C2wEventCard_ctn_share_disc ${isActive ? 'visible' : ''}`} style={{background : index === 2 ? 'transparent' : null}}>
                    {  index !== 2 ?  
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.37109 7.07031L7.30386 1.13754" stroke="white" stroke-width="1.18655" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.30386 7.07031V1.13754H1.37109" stroke="white" stroke-width="1.18655" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    : null}
                </div>
            </div>
        </div>
    )
}

export default C2wEventCard;
